import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import MainHeader from "../../components/MainHeader";
import Footer from "../../components/Footer";
import InterestsInitial from "../../components/Interests/InterestsInitial";
import InterestCauses from "../../components/Interests/InterestCauses";
import InterestRewards from "../../components/Interests/InterestRewards";
import Slider from "../../components/Slider";
import { setToastrTxt } from "../../redux/Cart/cart.actions";
import { handleUpdateInterests } from "../../redux/Auth/auth.helpers";
import { useHistory } from "react-router-dom";
import { startGetCategories } from "../../redux/Market/market.actions";

const SetInterests = ({ categories, dispatchSetToastrTxt, dispatchStartGetCategories }) => {
    const [causesCategories, setCausesCategories] = useState([]);
    const [rewardsCategories, setRewardsCategories] = useState([]);
    const [selections, setSelections] = useState({
        causesCategories: [],
        rewardsCategories: []
    });

    const history = useHistory();

    const { t } = useTranslation();

    useEffect(() => {
        if(!categories) {
            dispatchStartGetCategories();
        }
    }, []);

    useEffect(() => {
        setCausesCategories(categories?.causes || []);
        setRewardsCategories(categories?.products || []);
    }, [categories]);

    const handleSelection = (type, id) => {
        setSelections(prev => {
            const currentSelections = prev[type];
            const newSelections = currentSelections.includes(id)
                ? currentSelections.filter(item => item !== id)
                : [...currentSelections, id]
            return {
                ...prev,
                [type]: newSelections
            };
        });
    };

    const handleSubmit = async () => {
        const categories = [...selections.causesCategories, ...selections.rewardsCategories];
        try {
            const response = await handleUpdateInterests({categories});
            if (response?.success) {
                history.push("/create-success");
            } else {
                throw new Error();
            }
        } catch (error) {
            dispatchSetToastrTxt({
                title: t("toastr.interests_error"),
                err: true,
            });
        }
    };

    const interestsScreens = [
        <InterestsInitial />,
        <InterestCauses
            causesCategories={causesCategories}
            selectedCausesCategories={selections.causesCategories}
            onCausesCategoriesChange={(id) => handleSelection('causesCategories', id)}
        />,
        <InterestRewards 
            rewardsCategories={rewardsCategories}
            selectedRewardsCategories={selections.rewardsCategories}
            onRewardsCategoriesChange={(id) => handleSelection('rewardsCategories', id)}
        />
    ];

    return (
        <div className="min-h-screen flex flex-col">
            <MainHeader />
            <main className="flex-1 overflow-hidden w-full flex justify-center items-center">
                <div className="min-h-[650px] h-[650px] max-h-[650px] max-w-[800px]">
                    <Slider screens={interestsScreens} handleSubmit={handleSubmit} />
                </div>
            </main>
            <Footer />
        </div>
    );
};

const mapStateToProps = ({ market }) => ({
    categories: market.categories
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetToastrTxt: (toastr) => dispatch(setToastrTxt(toastr)),
    dispatchStartGetCategories: () => dispatch(startGetCategories()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetInterests);
